import PhraseScramblerContainer from 'components/Game/PhraseScrambler/PhraseScramblerContainer'
import PhraseScramblerData from 'components/Game/PhraseScrambler/PhraseScramblerData'
import PhraseScramblerPresentation from 'components/Game/PhraseScrambler/PhraseScramblerPresentation'

export default {
  Container: PhraseScramblerContainer,
  Data: PhraseScramblerData,
  Presentation: PhraseScramblerPresentation,
}
